import { useState } from 'react';
import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';
import { Button } from 'antd';
import moment from 'moment';

import { ISimuladorResponse } from '../../interfaces';
import { CollectResponse, EItemFormatType, EItemType } from '../../../SimuladorInteligente/interfaces';

import { formatStringList, formatValueToXLSX } from '../../../../utils/simulador';
import { convertDataUSParaBrasilEHora } from '../../../../services/Conversores';

interface IProps {
  data: ISimuladorResponse[],
}

export default function ExcelExportButton({
  data,
}: IProps) {
  const [isLoading, setIsLoading] = useState(false);

  const formatDataToSheet = (responses: ISimuladorResponse[]) => {
    const rows = responses.map((response) => {

      const item: { [key: string]: string | undefined } = {
        "Iniciado em": convertDataUSParaBrasilEHora(response.createdAt),
        "Finalizado em": convertDataUSParaBrasilEHora(response.fluxo_finalizado_em),
        "Status": response.fluxo_finalizado_em ? "Finalizado" : "Em preenchimento",
      };

      response.respostas.forEach((fluxoItem) => {
        if (fluxoItem.type === EItemType.OPTIONS && fluxoItem.table_display_name) {
          item[fluxoItem.table_display_name] = formatStringList(fluxoItem.response || []);
        }

        if (fluxoItem.type === EItemType.FIELD && fluxoItem.table_display_name) {
          const columnName = `${fluxoItem.table_display_name}${fluxoItem.format === EItemFormatType.CURRENCY ? ' (R$)' : ''}`;

          item[columnName] = formatValueToXLSX({ value: fluxoItem.response, format: fluxoItem.format });
        }

        if (fluxoItem.type === EItemType.COLLECT) {
          const fields = fluxoItem.response as CollectResponse[];

          fields.forEach((field) => {
            const columnName = `${field.label}${field.format === EItemFormatType.CURRENCY ? ' (R$)' : ''}`;
            item[columnName] = formatValueToXLSX({ value: field.value, format: field.format });
          })
        }

        if (fluxoItem.type === EItemType.RESULT && fluxoItem.table_display_name) {
          item[fluxoItem.table_display_name] = fluxoItem.result as string;
        }
      });

      return item;
    })

    return rows;
  }

  const exportToExcel = () => {
    setIsLoading(true);
    const formattedData = formatDataToSheet(data);

    const fileName = `respostas-${moment().format('DD-MM-YYYY-HH-mm-ss')}`
    const worksheet = utils.json_to_sheet(formattedData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'respostas');
    const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `${fileName}.xlsx`);
    setIsLoading(false);
  };

  return (
    <Button
      type="primary"
      className="botaoVerdeBaixarTodas"
      onClick={exportToExcel}
      loading={isLoading}
    >
      Gerar XLSX
    </Button>
  );
}
